module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 8.606bc446.png";